var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPycharm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-46.5647482%",
    y1: "50%",
    x2: "90.4496403%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C3F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-53.6961722%",
    y1: "105.498047%",
    x2: "133.923445%",
    y2: "-7.578125%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF84A",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7EB62",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FE077",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32DA84",
    offset: "27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789",
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20D68C",
    offset: "69%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED497",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19D1A9",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13CCC2",
    offset: "90%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BC6E1",
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C3F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.7014388%",
    y1: "115.958904%",
    x2: "77.7517986%",
    y2: "22.2488584%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24D788",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FD886",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41DA82",
    offset: "44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ADC7D",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AE077",
    offset: "69%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1E36E",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE865",
    offset: "93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1EB5E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.66216216%",
    y1: "201.742857%",
    x2: "118.558559%",
    y2: "-16.9428571%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24D788",
    offset: "6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FD886",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41DA82",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ADD7D",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79E077",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE076",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE173",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2E56B",
    offset: "92%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "111.835165%",
    y1: "50.480167%",
    x2: "-14.2197802%",
    y2: "49.3632568%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF84A",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF451",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2E964",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2E56B",
    offset: "92%"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-1)",
    points: "179.6 40.4 254.4 102.4 227.2 157.2 182.4 144.8 143.2 144.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-2)",
    points: "104 80.8 89.6 157.2 88.4 183.6 51.6 199.2 0 204.8 15.6 39.2 109.6 0 167.2 38"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-3)",
    points: "104 80.8 111.2 228.4 87.6 256 0 204.8 72 97.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-4)",
    points: "200.8 70 112 70 190.4 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-5)",
    points: "256 228.8 178 255.6 74 226.4 104 80.8 116 70 179.6 64 173.6 127.6 224 108"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 48,
    y: 48,
    width: 160,
    height: 160
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,178 L123.2,178 L123.2,188 L63.2,188 L63.2,178 Z M62.8,68.8 L90,68.8 C106,68.8 115.2,78 115.2,91.6 C115.2,106.8 103.2,114.8 88.4,114.8 L77.2,114.8 L77.2,134.8 L62.8,134.8 L62.8,68.8 L62.8,68.8 Z M100.4,92.4 C100.4,86 96,82.4 88.4,82.4 L77.2,82.4 L77.2,102.8 L88.8,102.8 C96.66,102.8 100.4,98 100.4,92.4 Z M120.8,102.4 C120.595762,93.2154633 124.154413,84.3465202 130.650467,77.8504665 C137.14652,71.3544128 146.015463,67.7957616 155.2,68 C167.6,68 175.2,72 181.2,78.4 L172,89.2 C166.8,84.4 161.6,81.6 155.2,81.6 C144,81.6 136,90.8 136,102.4 C136,113.6 144,123.2 155.2,123.2 C162.8,123.2 167.6,120 172.8,115.6 L182,124.8 C175.2,132 167.6,136.8 154.8,136.8 C145.712905,136.800629 137.003697,133.16364 130.615836,126.700628 C124.227975,120.237615 120.693093,111.486466 120.8,102.4 Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPycharm);
export default __webpack_public_path__ + "static/media/pycharm.21c364c25aa2280535ae3dc579c76254.svg";
export { ForwardRef as ReactComponent };